import React, { FC } from 'react';

const IconResetFilters: FC = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="15" height="15" rx="4" fill="#211F24" />
      <path d="M4 4L7.5 7.5M7.5 7.5L11 4M7.5 7.5L4 11M7.5 7.5L11 11" stroke="#AAAAAA" />
    </svg>
  );
};

export default IconResetFilters;
